import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page" className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-slate-50 border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl py-6">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 transition-colors font-medium"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-6 max-w-4xl py-12">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">
            <strong>Last Updated:</strong> December 2025
          </p>

          <p className="text-slate-600 mb-6">
            Cozy Nests ("we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you use our services or visit our website.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Information We Collect
          </h2>
          <p className="text-slate-600 mb-4">
            We may collect the following types of information:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Personal Information:</strong> Name, phone number, email address, and physical address when you book an appointment.</li>
            <li><strong>Pet Information:</strong> Pet type, breed, and any special care requirements.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our website.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            How We Use Your Information
          </h2>
          <p className="text-slate-600 mb-4">
            We use the information we collect to:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Schedule and manage your grooming appointments</li>
            <li>Send appointment reminders and confirmations</li>
            <li>Communicate with you about our services</li>
            <li>Improve our website and services</li>
            <li>Respond to your inquiries and requests</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Information Sharing
          </h2>
          <p className="text-slate-600 mb-6">
            We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>With your consent</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and safety</li>
          </ul>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Data Security
          </h2>
          <p className="text-slate-600 mb-6">
            We implement reasonable security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2 className="font-heading text-xl font-bold text-slate-900 mt-8 mb-4">
            Contact Us
          </h2>
          <p className="text-slate-600 mb-4">
            If you have questions about this Privacy Policy, please contact us at:
          </p>
          <div className="text-slate-600 mb-8">
            <p><strong>Cozy Nests</strong></p>
            <p>20 E 22nd St #4699, New York, NY 10165</p>
            <p>Phone: +1-888-8801-344</p>
            <p>Email: bookings@cozynests.store</p>
          </div>
        </div>
      </main>
    </div>
  );
}
